var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center radius-10"},[_c('CreateForm',{attrs:{"isManagement":true,"status":_vm.status,"enableManager":_vm.enableManager}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }